import moment from 'moment';
import {
  DOC_FORMAT_CONFIG_VALUES,
  MAX_OPEN_FILE_SIZE,
  DOCUMENT_TYPE,
  USE_REACT_ROUTER,
  DIALOG_TYPE,
  PO_EDIT_MODE,
  DOC_FORMAT_CONFIG_PREDEFINED
} from '../define/global';
// import * as ExcelJS from 'exceljs'; //^4.2.1
// import * as intoStream from 'into-stream'; //^7.0.0
// import chardet from 'chardet'; //^1.3.0
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useGenConfirmPromise } from '../components/confirm/Confirm';
import ga from './gaConnect';
import { isDevicePC, isSupportDocFormat, useCheckWrongSupportDocFormat } from './util';
import { showToast } from '../store/modules/toast';
import { useAppDataSliceSelector } from '../store/modules/appData';
import { TOAST_ALIGN } from '../components/common/Toast';
import { usePOWebofficeSDKState } from '../context/poWebOfficeSDKContext';
import { saveFile, useIndexedDBDispatch, useIndexedDBState } from '../context/indexedDBContext';
import { openDialog } from '../store/modules/dialog';
import { useDocInfoSliceSelector } from '../store/modules/docInfo';

const getExtension = (filename) => {
  return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
};

const getFileNameOnly = (filename) => {
  return filename.slice(0, filename.lastIndexOf('.'));
};

const convFileNameHWPXToHWP = (fileName) => {
  const fileExt = getExtension(fileName).toLowerCase();
  if (fileExt === 'hwpx') {
    return `${getFileNameOnly(fileName)}.hwp`;
  }

  return fileName;
};

const getFileFormat = (fileName) => {
  const ext = getExtension(fileName);
  for (const key in DOC_FORMAT_CONFIG_PREDEFINED) {
    if (DOC_FORMAT_CONFIG_PREDEFINED[key].extList.includes(ext.toLowerCase())) {
      return key;
    }
  }

  return '';
};

const decomposeFileName = (fileName) => {
  const fileExt = getExtension(fileName);
  const fileNameOnly = getFileNameOnly(fileName);

  return { fileNameOnly, fileExt };
};

const isFileNameOnlyDot = (fileName) => {
  if (fileName && fileName.length > 0) {
    const convName = fileName.replaceAll('.', '');
    if (convName === '') {
      return true;
    }
  }
  return false;
};

const convertMBToByte = (size) => {
  return size * 1024 * 1024;
};

const formatBytes = (bytes, decimals = 1) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

const convertToLowerCaseExt = (fileName) => {
  if (fileName === undefined) return '';
  if (fileName === '') return fileName;

  const dotPos = fileName.lastIndexOf('.');
  if (dotPos === -1) return fileName;

  return getFileNameOnly(fileName) + '.' + getExtension(fileName).toLowerCase();
};

const downloadFileWithBlob = (fileName, blob) => {
  const link = document.createElement('a');
  link.style.display = 'none';
  document.body.appendChild(link);

  let copyedBLOB = blob;

  //https://jira.polarisoffice.net/browse/WXP-346
  //application/hwp 가 마임타입이면, hwp 를 확장자로 인식하지 못하고,
  //파일이름으로 인식해서, 파일 이름이 겹칠경우, 확장자 뒤에 숫자를 붙혀서
  //알수 없는 확장가 되버린다.
  if (blob.type === 'application/hwp') {
    copyedBLOB = new Blob([blob], { type: 'application/x-hwp' });
  }

  const url = window.URL.createObjectURL(copyedBLOB);
  link.href = url;

  const fileExt = getExtension(fileName);
  const convFileName =
    fileExt === DOCUMENT_TYPE.HWP && isFileNameOnlyDot(getFileNameOnly(fileName))
      ? `download.${fileExt}`
      : fileName;

  link.download = convFileName;
  link.click();
  //window.URL.revokeObjectURL(url);
  document.body.removeChild(link);

  //WAD-612 : This issue occurs in IOS
  //Delay called revokeObjectURL method
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 200);
};

const genNewFileName = () =>
  `New Document ${moment().format('YYYY-MM-DD HHmmss')}${DOC_FORMAT_CONFIG_VALUES.defaultExt}`;

// const useConvertCsvtoXlsx = () => {
//   const { i18n } = useTranslation();
//   const confirmPromise = useGenConfirmPromise();
//   return async function (csvFile) {
//     try {
//       const onlyFileName = getFileNameOnly(csvFile.name);
//       const convExcel = (csvFile) => {
//         return new Promise(async (resolve, reject) => {
//           const workbook = new ExcelJS.Workbook();
//           workbook.created = new Date();
//           workbook.modified = new Date();
//           workbook.properties.date1904 = true;

//           csvFile.arrayBuffer().then(async (buf) => {
//             const detectEncoding = await chardet.detect(Buffer.from(buf));
//             const message =
//               detectEncoding === 'UTF-8'
//                 ? i18n.t('Common.ConfirmConvert')
//                 : `${i18n.t('Common.ConfirmUnsupportedEncoding')}\n${i18n.t(
//                     'Common.ConfirmConvert'
//                   )}`;

//             const userConfirm = await confirmPromise({ message });
//             if (userConfirm) {
//               await workbook.csv.read(intoStream.default(buf), {
//                 sheetName: onlyFileName
//               });
//               resolve(workbook.xlsx.writeBuffer());
//             } else {
//               reject(csvFile);
//               return;
//             }
//           });
//         });
//       };
//       const buffer = await convExcel(csvFile);

//       return new File([buffer], `${onlyFileName}.xlsx`, {
//         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
//       });
//     } catch (err) {
//       throw err;
//     }
//   };
// };

const useDoFlowByCheckingResult = () => {
  const appDataSlice = useAppDataSliceSelector();
  const confirmPromise = useGenConfirmPromise();
  const checkWrongSupportDocFormat = useCheckWrongSupportDocFormat();
  const isPCView = isDevicePC(appDataSlice.deviceType);
  const toastAlign = isPCView === true ? undefined : TOAST_ALIGN.BOTTOM;
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const indexedDBState = useIndexedDBState();
  const indexedDBDispatch = useIndexedDBDispatch();

  const checkOpenableFile = async ({ file, isNaverWorksFile, naverWorksFileInfo }) => {
    let fileExt = getExtension(file.name);
    let fileSize = file.size;
    let result = checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.OPENABLE;
    let targetFile = file;

    // if (
    //   fileExt === DOCUMENT_TYPE.CSV &&
    //   DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.SHEET
    // ) {
    //   try {
    //     targetFile = await confirmFormatConvert(file);
    //     fileSize = targetFile.size;
    //     fileExt = getExtension(targetFile.name);
    //   } catch (err) {
    //     targetFile = file;
    //     result = checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.DO_NOTHING;
    //   }
    // }

    if (isSupportDocFormat(fileExt) === false) {
      const isRedirect = checkWrongSupportDocFormat(fileExt);
      if (isRedirect) {
        const waitConfirm = await confirmPromise({
          message: i18n.t('OpenWithDragNDrop.OpenNewCorrectTab', {
            FORMAT: isRedirect.correctFormat
          })
        });
        if (waitConfirm) {
          let targetUrl = isRedirect.correctUrl;
          if (USE_REACT_ROUTER === true) {
            await saveFile({
              state: indexedDBState,
              dispatch: indexedDBDispatch,
              file: targetFile,
              isNaverWorksFile,
              naverWorksFileInfo
            });
            targetUrl = isRedirect.correctUrl;
          }

          window.open(targetUrl, '_blank', 'noopener,noreferrer');
        }
        result = checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.DO_NOTHING;
      } else {
        result = checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.NOT_SUPPORT_FORMAT_EXTENTION;
      }
    } else if (fileSize > convertMBToByte(MAX_OPEN_FILE_SIZE)) {
      result = checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.OVERSIZE_FILE;
    }

    return { result, fileExt, fileSize, targetFile };
  };

  checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT = {
    NOT_SUPPORT_FORMAT_EXTENTION: 1,
    OVERSIZE_FILE: 2,
    OPENABLE: 3,
    DO_NOTHING: 4
  };

  return async function ({ file, isNaverWorksFile, naverWorksFileInfo, openableCallback }) {
    const { result, fileExt, fileSize, targetFile } = await checkOpenableFile({
      file,
      isNaverWorksFile,
      naverWorksFileInfo
    });
    switch (result) {
      case checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.NOT_SUPPORT_FORMAT_EXTENTION:
        ga.event({ category: '예외 케이스', action: '열람실패_미지원', label: fileExt });
        dispatch(showToast({ msg: i18n.t('FileMenu.UnsupportedFormat'), align: toastAlign }));
        break;
      case checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.OVERSIZE_FILE:
        ga.event({ category: '예외 케이스', action: '열람실패_사이즈', value: fileSize });
        dispatch(
          showToast({
            msg: i18n.t('FileMenu.LimitFileSize', {
              MAX_OPEN_FILE_SIZE: MAX_OPEN_FILE_SIZE
            }),
            align: toastAlign
          })
        );
        break;
      case checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.OPENABLE:
        openableCallback(targetFile);
        break;
      case checkOpenableFile.OPENABLE_FILE_CHEKING_RESULT.DO_NOTHING:
        break;
      default:
        break;
    }
  };
};

const useExportPDF = () => {
  const poSDKContextState = usePOWebofficeSDKState();
  return function ({ target, customRange }) {
    return new Promise((resolve, reject) => {
      poSDKContextState.poInstance.handle
        .exportAsPDF({
          target,
          customRange,
          isPdfAExport: false
        })
        .then((arg) => {
          resolve(arg);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  };
};

const useDoFlowByDownload = () => {
  //const appDataSlice = useAppDataSliceSelector();
  const docInfoSlice = useDocInfoSliceSelector();
  const confirmPromise = useGenConfirmPromise();
  // const isPCView = isDevicePC(appDataSlice.deviceType);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  return async function (from, fileName) {
    if (!fileName || fileName === '') return false;
    let bDownload = true;
    if (docInfoSlice.poEditMode === PO_EDIT_MODE.EDIT) {
      if (getExtension(docInfoSlice.fileName).toLowerCase() === DOCUMENT_TYPE.CSV) {
        bDownload = await confirmPromise({
          title: i18n.t('Common.Notification'),
          message: i18n.t('DocumentDownloadDialog.DownloadCSVWarning')
        });
      }
    }

    if (bDownload) {
      dispatch(openDialog({ dialogType: DIALOG_TYPE.DIALOG_DOWNLOAD_DOCUMENT, arg: { from } }));
    }

    return bDownload;
  };
};

export {
  getExtension,
  downloadFileWithBlob,
  genNewFileName,
  getFileFormat,
  convertMBToByte,
  formatBytes,
  getFileNameOnly,
  convFileNameHWPXToHWP,
  convertToLowerCaseExt,
  decomposeFileName,
  isFileNameOnlyDot,
  useDoFlowByCheckingResult,
  useExportPDF,
  useDoFlowByDownload
};
